import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { City } from '../interfaces/city';
import { PostalCode } from '../interfaces/postal-code';

@Injectable({
  providedIn: 'root'
})
export class LocalisationService {

    constructor(private http: HttpClient) { }

    public getCities(search: string) : Observable<City[]> {
        return this.http.get<City[]>('https://geo.api.gouv.fr/communes?nom=' + encodeURIComponent(search) + '&fields=departement&boost=population&limit=5');
    }

    public getCitiesByPostalCode(search: string): Observable<PostalCode[]> {
        return this.http.get<PostalCode[]>('https://geo.api.gouv.fr/communes?codePostal=' + encodeURIComponent(search) + '&fields=departement&boost=population&limit=5');
    }  
}
